
<template>
  <table width="100%"  border="0">
    <tr>
      <td>
        <table width="100%" border="0">
          <tr>
            <td>
              Mailto:<br />
              <input type="text" v-model="value.Target"  @changed="changed" class="form-control" />
            </td>
          </tr>
          <tr>
            <td>
              Body:<br />
              <textarea v-model="value.TargetValue" @changed="changed" class="form-control" v-bind:placeholder="'Mail content with some templated value\nsuch as {{Priority}}'"></textarea>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</template>

<script>
  export default {
    name: 'conditions-mail',
    components: {
    },
    data() {
      return {
      }
    },
    props: {
      value: {
        required: false,
        type: Object,
        default() {
          return {}
        }
      },

    },
    methods: {
      changed(el) {
        this.$forceUpdate();
        this.$emit('change');
      },

    },
  
  created() {
    
  },

  mounted() {
  },

  computed: {
      
     
  },
}
</script>



// WEBPACK FOOTER //
// src/components/conditions/conditions-mail.vue